package api

object APIEndpoints {
//    private const val rootURL = "http://amsterdam.icsvertex.nl/WMS_ONTW_ICS_WMS_Portal_Web_API"
    private const val rootURL = "https://api.hartevelt.net/PROD_ICS_WMS_Portal_Web_API"
    const val login = "$rootURL/User/Login"
    const val refreshTokenUrl = "$rootURL/User/RefreshToken"
    const val stockListURL = "$rootURL/Api/Stock"
    const val receiveOrdersListURL = "$rootURL/Receive/Receiveorders"
    const val receiveOrdersDetailURL = "$rootURL/Receive/Receiveorderdetail?RecordId="
    const  val receiveOrderlinesURL = "$rootURL/Receive/Receiveorderlines?RecordId="
    const val pickOrdersListURL = "$rootURL/Pick/Pickorders"
    const val pickOrdersDetailURL = "$rootURL/Pick/Pickorderdetail?RecordId="
    const val pickOrderlinesURL = "$rootURL/Pick/Pickorderlines?RecordId="
    const val deliveryOrdersListURL = "$rootURL/Delivery/Deliveryorders"
    const val deliveryOrdersDetailURL = "$rootURL/Delivery/Deliveryorderdetail?RecordId="
}
